import { Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { environment } from '../../../../../environments/environment';
import { UserTypeEnum } from '@oranta-mis/sdk';

declare global {
  interface Window {
    google: any;
  }
}

@Component({
  selector: 'sign-in-google',
  templateUrl: './google.component.html',
  styleUrl: './google.component.scss',
  standalone: true,
})
@UntilDestroy()
export class SignInGoogleComponent implements OnInit {
  public readonly environment = environment;
  @Input({ required: true }) public whoSignIn!: UserTypeEnum;
  @Output() public googleCredentials: EventEmitter<string> = new EventEmitter<string>();

  constructor(private readonly ngZone: NgZone) {}

  ngOnInit(): void {
    window.google.accounts.id.initialize({
      client_id: environment.authGoogleClientId,
      callback: (response: any) => this.handleCredentialResponse(response),
    });

    this.renderGoogleButton();
    window.addEventListener('resize', this.renderGoogleButton.bind(this));
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.renderGoogleButton.bind(this));
  }

  renderGoogleButton() {
    const width = Math.min(Math.max(window.innerWidth * 0.8, 200), 400);

    window.google.accounts.id.renderButton(document.getElementById('g_id_onload'), {
      type: 'standard',
      shape: 'rectangular',
      theme: 'outline',
      text: 'continue_with',
      size: 'large',
      logo_alignment: 'left',
      width: width.toString(),
    });
  }

  handleCredentialResponse(response: any) {
    this.ngZone.run(() => {
      this.googleCredentials.emit(response.credential);
    });
  }
}
